import moment from 'moment'

export default {
    name: 'courses-materials-item',
    props: {
        item: {
            type: Object,
            default: {}
        }
    },
    methods: {
        formattedDate(item) {
            const date = moment(item.date_at).format('DD MMMM, YYYY');
            const timeStart = moment(item.date_at).format('HH:mm');
            if (item.hasOwnProperty('endedAt')) {
                const timeEnd = moment(item.endedAt).format('HH:mm');
                return `${date} · ${timeStart} ${' – ' + timeEnd}`
            } else {
                return `${date} · ${timeStart}`
            }
        }
    }
}
